import axios from "axios";
import { getBrowserFingerprint } from "@/utils/browserFingerprint";

// axios基础配置
const axiosInstance = axios.create({
    // 接口地址
    baseURL: process.env.VUE_APP_BASE_API,
    // 超时时间
    timeout: 10000,
})
// 请求拦截
axiosInstance.interceptors.request.use(
    (config) => {
        if (config) {
            // 公开 AI 分享支持匿名读取，不注入会触发跨域预检的身份请求头。
            const isPublicAiShare = config.method === 'get' &&
                config.url?.startsWith('/ai-chat/public/shares/');
            // 在请求头里面加东西
            if (config.headers && !isPublicAiShare) {
                let TOKEN = localStorage.getItem("authToken");
                if (TOKEN) {
                    config.headers['authToken'] = TOKEN;
                }
                config.headers['clientId'] = getBrowserFingerprint();
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
)
export default axiosInstance;
